// extracted by mini-css-extract-plugin
export default {"deleteModal":"styles_deleteModal__18-G9","content":"styles_content__F2RjB","body":"styles_body__GR9-u","promptTxt":"styles_promptTxt__uIXPC","promptBtn":"styles_promptBtn__k-nic"};